import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const SESSION_KEY = "ovo_signup_ref";

export function persistSignupReferralCode(code) {
  const normalized = String(code || "").trim().toUpperCase();
  if (normalized && typeof sessionStorage !== "undefined") {
    sessionStorage.setItem(SESSION_KEY, normalized);
  }
  return normalized;
}

export function peekSignupReferralCode() {
  if (typeof window === "undefined") return "";
  const fromUrl = new URLSearchParams(window.location.search).get("ref") || "";
  const fromSession = sessionStorage.getItem(SESSION_KEY) || "";
  return String(fromUrl || fromSession || "").trim().toUpperCase();
}

async function sha256Hex(value) {
  const encoded = new TextEncoder().encode(value);
  const buf = await crypto.subtle.digest("SHA-256", encoded);
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
}

export async function emailIdentityHash(email) {
  const normalized = String(email || "").trim().toLowerCase();
  if (!normalized) return null;
  return sha256Hex(`email:${normalized}`);
}

/**
 * Park the referral code for Auth onCreate / onReferralIntentCreated.
 * Does not award credits — Cloud Functions own that.
 */
export async function writeReferralIntent({ uid, email, code }) {
  const normalized = persistSignupReferralCode(code);
  if (!normalized) return null;

  const payload = {
    code: normalized,
    createdAt: serverTimestamp(),
  };
  if (uid) payload.uid = uid;
  if (email) payload.email = String(email).trim().toLowerCase();

  if (uid) {
    await setDoc(doc(db, "referralIntents", uid), payload, { merge: true });
  }

  if (email) {
    const emailHash = await emailIdentityHash(email);
    if (emailHash) {
      await setDoc(doc(db, "referralIntents", emailHash), {
        ...payload,
        emailHash,
      }, { merge: uid ? true : false });
    }
  }

  return normalized;
}
